// extracted by mini-css-extract-plugin
export var adjacentSlide = "_l2-9";
export var arrowButtonContainer = "_l2-5";
export var arrowButtonIcon = "_l2-6";
export var carouselArrowButton = "_l2-2";
export var carouselElementContainer = "_l2-1";
export var currentSlide = "_l2-8";
export var left = "_l2-3";
export var otherSlide = "_l2-a";
export var productCarouselContainer = "_l2-0";
export var right = "_l2-4";
export var sliderOverflow = "_l2-7";